<template>
  <div>
    <div v-if="questions.length > 1" class="q-and-a max-w-2xl mx-auto">
      <div class="question">
        <div class="u-h2">{{ questions[0].label }}</div>
      </div>
      <div class="answer">
        <select v-model="$root.countries.selected" class="appearance-none">
          <option
            v-for="c in $root.countries.list"
            :key="`country${c.name}`"
            :value="c.value"
          >
            {{ c.name }}
          </option>
        </select>
      </div>
    </div>

    <!-- Other Country -->
    <div
      v-if="$root.countries.selected === 'other'"
      class="q-and-a max-w-2xl mx-auto"
    >
      <div class="question">
        <div class="u-h2">{{ $root.globalOptions.other_country.label }}</div>
      </div>
      <div class="answer">
        <input
          v-model="$root.countries.otherName"
          type="text"
          :placeholder="$root.globalOptions.other_country.placeholder"
          required
        />
      </div>
    </div>

    <RangeSlider v-bind="questions[1] || questions[0]" :class="rangeSliderClasses" />
  </div>
</template>

<script>
import RangeSlider from '@/components/RangeSlider.vue';
export default {
  props: ['questions'],
  components: { RangeSlider },
  data: () => ({}),
  computed: {
    rangeSliderClasses() {
      return typeof this.questions[1] !== 'undefined' ? 'mt-12': '';
    }
  },
};
</script>

<style lang="scss" scoped>
.answer {
  @screen md {
    flex: 0 0 285px;
  }
}
</style>
